import React from 'react';
import Title, { TitleProps } from '@vkontakte/vkui/dist/components/Typography/Title/Title';
import styled from '@material-ui/styles/styled';

export default styled(Title)({
  '&.Title--w-bold, &.Title--w-heavy': {
    fontFamily: 'var(--font-tt)',
  },
}) as React.FC<TitleProps>;
